export default __webpack_public_path__ + "static/media/close.bde99513.svg";